<template>
  <view>
    <slot />
  </view>
</template>

<script setup>
import propsConfig from '@/uni_modules/thorui/tui-config/index.js'
uni.$tui = propsConfig
</script>
